import * as mapbox from 'mapbox-gl';
import { useState, useEffect } from 'react';

export const useMarker = (
    map: mapbox.Map,
    position: mapbox.LngLatLike,
    clickable: boolean,
    size: number = 25,
) => {
    const [marker, setMarker] = useState<mapbox.Marker>();

    useEffect(() => {
        const createMarkerEl = () => {
            const el = document.createElement('img');
            el.src = '/_shared/img/location_pin_alt.svg';
            el.style.width = `${size}px`;
            el.style.height = `${size}px`;

            if (clickable) {
                el.style.cursor = 'pointer';
            }

            return el;
        };

        const createMarker = () => {
            const m = new mapbox.Marker({
                element: createMarkerEl(),
                anchor: 'bottom',
            });

            m.setLngLat(position)
             .addTo(map);

            return m;
        };

        setMarker(createMarker());
    }, [map, position]);

    return marker;
};
